import { ReactNode, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useGetAdminConfigQuery } from "../api/AdminConfigApi";
import { setAdminConfig } from "../../../stores/AdminConfigSlice";

export function AdminConfig({children}: { children: ReactNode }) {
  const dispatch = useDispatch();
  const {data} = useGetAdminConfigQuery();

  useEffect(() => {
    if (!data) {
      return;
    }
    dispatch(setAdminConfig(data));
  }, [data, dispatch]);

  if (!data) {
    return null;
  }

  return (
    <>
      {children}
    </>
  );
}
